/**
 * ---------------------------------------------------------------------------------------------------------------------
 * MODAL "COMPLETE THE LOOK" — Cubitt (Impact 4.4.0 + Rebuy Smart Cart)
 * ---------------------------------------------------------------------------------------------------------------------

 */
(function () {
  'use strict';

  var SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  var SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  var CACHE_VERSION = 'v2';
  var CACHE_TTL = 30 * 60 * 1000; // 30 minutos
  var FETCH_TIMEOUT = 8000;
  var OPEN_MAX_WAIT = 4000; // si los sugeridos no están listos en este tiempo, no se abre el modal
  var IMAGE_WIDTHS = [200, 300, 400, 500, 600, 800];
  var MAX_SWATCHES = 4; // igual que el product-card de colecciones: 4 colores + botón "+N"

  var BUTTON_LABELS = {
    add: { key: 'labelAdd', fallback: 'Add to cart' },
    adding: { key: 'labelAdding', fallback: 'Adding…' },
    added: { key: 'labelAdded', fallback: 'Added' },
    'sold-out': { key: 'labelSoldOut', fallback: 'Sold out' },
    error: { key: 'labelError', fallback: 'Try again' },
    'add-again': { key: 'labelAddAgain', fallback: 'Add another' },
    'select-model': { key: 'labelSelectModel', fallback: 'Select your model' }
  };

  var modal = document.getElementById('ctl-modal');
  if (!modal || modal.dataset.ctlReady === 'true') return;
  modal.dataset.ctlReady = 'true';

  var config = {
    productId: String(modal.dataset.productId),
    handle: modal.dataset.productHandle,
    title: modal.dataset.productTitle || '',
    compatModel: modal.dataset.compatModel || '',
    ruleset: modal.dataset.ruleset,
    apiKey: modal.dataset.apiKey,
    limit: parseInt(modal.dataset.limit, 10) || 10,
    hideSmartCart: modal.dataset.hideSmartCart !== 'false',
    perView: {
      mobile: parseFloat(modal.dataset.perViewMobile) || 2,
      tablet: parseFloat(modal.dataset.perViewTablet) || 2.5,
      desktop: parseFloat(modal.dataset.perViewDesktop) || 3
    }
  };

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var track = modal.querySelector('[data-ctl-track]');
  var statusEl = modal.querySelector('[data-ctl-status]');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var state = {
    loadPromise: null,
    count: 0,
    swiper: null,
    isOpen: false,
    lastFocus: null,
    added: {} // { variantId: cantidad agregada desde el modal }
  };

  var viewCartButton = modal.querySelector('[data-ctl-view-cart]');
  var viewCartLabel = viewCartButton ? viewCartButton.textContent.trim() : 'View cart';

  /* ================================================================================================================
     UTILIDADES
     ================================================================================================================ */

  function normalize(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function delay(ms, value) {
    return new Promise(function (resolve) {
      setTimeout(function () { resolve(value); }, ms);
    });
  }

  function fetchWithTimeout(url, options) {
    var controller = 'AbortController' in window ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, FETCH_TIMEOUT) : null;
    var opts = Object.assign({}, options || {}, controller ? { signal: controller.signal } : {});

    return fetch(url, opts).finally(function () {
      if (timer) clearTimeout(timer);
    });
  }

  function cacheKey() {
    return 'ctl:' + CACHE_VERSION + ':' + config.ruleset + ':' + config.productId;
  }

  function readCache() {
    try {
      var raw = sessionStorage.getItem(cacheKey());
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || Date.now() - data.t > CACHE_TTL) return null;
      return data.items;
    } catch (e) {
      return null;
    }
  }

  function writeCache(items) {
    try {
      sessionStorage.setItem(cacheKey(), JSON.stringify({ t: Date.now(), items: items }));
    } catch (e) { /* sessionStorage lleno o bloqueado: se ignora */ }
  }

  function announce(message) {
    if (!statusEl) return;
    statusEl.textContent = '';
    setTimeout(function () { statusEl.textContent = message; }, 50);
  }

  /* ================================================================================================================
     REBUY → LISTA DE HANDLES
     ================================================================================================================ */

  function fetchSuggestions() {
    var cached = readCache();
    if (cached) return Promise.resolve(cached);

    var params = new URLSearchParams({
      key: config.apiKey,
      shopify_product_ids: config.productId,
      limit: String(config.limit + 2) // margen para compensar duplicados
    });

    var url = 'https://rebuyengine.com/api/v1/custom/id/' + config.ruleset + '?' + params.toString();

    return fetchWithTimeout(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Rebuy respondió ' + response.status);
        return response.json();
      })
      .then(function (json) {
        var seen = {};
        seen[config.productId] = true;

        var items = [];
        (json.data || []).forEach(function (product) {
          if (!product || !product.handle || seen[product.id]) return;
          seen[product.id] = true;
          items.push({ handle: product.handle });
        });

        items = items.slice(0, config.limit);
        writeCache(items);
        return items;
      });
  }

  /* ================================================================================================================
     SHOPIFY → HTML DE CADA TARJETA
     ================================================================================================================ */

  function fetchCard(item) {
    var url = root + 'products/' + encodeURIComponent(item.handle) + '?view=ctl-card';

    return fetchWithTimeout(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Tarjeta ' + item.handle + ' respondió ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('[data-ctl-card]');
        if (!card) throw new Error('Sin tarjeta para ' + item.handle);

        // product-badges trae un <script>/<style> pensado para la página principal: no debe vivir en el modal
        card.querySelectorAll('script:not([data-ctl-variants]), style').forEach(function (el) { el.remove(); });

        return card;
      });
  }

  function load() {
    if (state.loadPromise) return state.loadPromise;

    state.loadPromise = fetchSuggestions()
      .then(function (items) {
        return Promise.allSettled(items.map(fetchCard));
      })
      .then(function (results) {
        var fragment = document.createDocumentFragment();

        results.forEach(function (result) {
          if (result.status !== 'fulfilled') return;

          var card = document.importNode(result.value, true);
          initCard(card);

          var slide = document.createElement('div');
          slide.className = 'swiper-slide ctl-slider__slide';
          slide.appendChild(card);
          fragment.appendChild(slide);
        });

        track.innerHTML = '';
        track.appendChild(fragment);
        state.count = track.children.length;
        modal.dataset.count = String(state.count);
        return state.count;
      })
      .catch(function (error) {
        console.warn('[Complete the look]', error);
        state.count = 0;
        state.loadPromise = null; // permite reintentar en el siguiente "agregar al carrito"
        return 0;
      });

    return state.loadPromise;
  }

  /* ================================================================================================================
     TARJETA: VARIANTES, PRECIO, IMAGEN, BOTÓN
     ================================================================================================================ */

  function getVariants(card) {
    if (!card._ctlVariants) {
      try {
        card._ctlVariants = JSON.parse(card.querySelector('[data-ctl-variants]').textContent);
      } catch (e) {
        card._ctlVariants = [];
      }
    }
    return card._ctlVariants;
  }

  /**
   * Muestra máximo MAX_SWATCHES colores y agrega un botón "+N" que despliega el resto.
   * Si el color seleccionado está entre los ocultos, ocupa el último lugar visible.
   */
  function collapseSwatches(card) {
    var list = card.querySelector('.ctl-card__swatches');
    if (!list) return;

    var inputs = list.querySelectorAll('input[type="radio"]');
    if (inputs.length <= MAX_SWATCHES) return;

    var checkedIndex = -1;
    inputs.forEach(function (input, index) {
      if (input.checked) checkedIndex = index;
    });

    var hiddenCount = 0;
    inputs.forEach(function (input, index) {
      var visible = index < MAX_SWATCHES || index === checkedIndex;
      if (checkedIndex >= MAX_SWATCHES && index === MAX_SWATCHES - 1) visible = false;
      if (visible) return;

      var label = list.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      if (label) {
        label.hidden = true;
        label.classList.add('ctl-card__swatch--extra');
        hiddenCount++;
      }
    });

    var more = document.createElement('button');
    more.type = 'button';
    more.className = 'color-swatch__view-more rounded-full text-xxs text-subdued ctl-card__more';
    more.setAttribute('data-ctl-more', '');
    more.setAttribute('aria-label', 'Show ' + hiddenCount + ' more colors');
    more.textContent = '+' + hiddenCount;
    list.appendChild(more);
  }

  function expandSwatches(list) {
    if (!list || list.classList.contains('is-expanded')) return;

    list.querySelectorAll('.ctl-card__swatch--extra').forEach(function (label) {
      label.hidden = false;
    });

    var more = list.querySelector('[data-ctl-more]');
    var hadFocus = more && document.activeElement === more;
    if (more) more.remove();

    list.classList.add('is-expanded');
    if (state.swiper) state.swiper.update();

    // El botón desaparece: el foco pasa al color seleccionado para no perderse
    if (hadFocus) {
      var checked = list.querySelector('input:checked');
      if (checked) checked.focus({ preventScroll: true });
    }
  }

  function initCard(card) {
    // Evita que Swiper arrastre el slider al usar swatches o selects
    card.querySelectorAll('[data-ctl-option]').forEach(function (el) {
      el.classList.add('swiper-no-swiping');
    });

    collapseSwatches(card);
    markUnavailableValues(card);
    resolveModel(card);
  }

  // Productos de una sola opción: marca los valores agotados
  function markUnavailableValues(card) {
    var optionEls = card.querySelectorAll('[data-ctl-option]');
    if (optionEls.length !== 1) return;

    var optionEl = optionEls[0];
    getVariants(card).forEach(function (variant) {
      if (variant.available) return;
      var value = variant.options[0];

      if (optionEl.tagName === 'SELECT') {
        Array.prototype.forEach.call(optionEl.options, function (opt) {
          if (opt.value === value) opt.textContent = value + ' — Sold out';
        });
      } else {
        optionEl.querySelectorAll('input[type="radio"]').forEach(function (input) {
          if (input.value !== value) return;
          var label = optionEl.querySelector('label[for="' + CSS.escape(input.id) + '"]');
          if (label) label.classList.add('is-unavailable');
        });
      }
    });
  }

  /* ----------------------------------------------------------------------------------------------------------------
     MODELO COMPATIBLE (tres capas)
       1. Metacampo de variante custom.accessory_model del accesorio  ← fuente de verdad
       2. Deducción por el título del reloj (palabras completas, coincidencia más larga)
       3. Si ninguna resuelve: no se adivina, el cliente elige su modelo
     ---------------------------------------------------------------------------------------------------------------- */

  function getOptionEl(card, name) {
    var els = card.querySelectorAll('[data-ctl-option]');
    for (var i = 0; i < els.length; i++) {
      if (normalize(els[i].dataset.optionName) === normalize(name)) return els[i];
    }
    return null;
  }

  function words(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(' ').filter(Boolean);
  }

  // ¿Aparecen las palabras de "needle" seguidas dentro de "haystack"?
  function containsSequence(haystack, needle) {
    if (!needle.length || needle.length > haystack.length) return false;

    for (var i = 0; i <= haystack.length - needle.length; i++) {
      var match = true;
      for (var j = 0; j < needle.length; j++) {
        if (haystack[i + j] !== needle[j]) { match = false; break; }
      }
      if (match) return true;
    }
    return false;
  }

  // Capa 1
  function matchByMetafield(card) {
    if (!config.compatModel) return null;

    var target = normalize(config.compatModel);
    var variants = getVariants(card);

    for (var i = 0; i < variants.length; i++) {
      var models = variants[i].models || [];
      for (var j = 0; j < models.length; j++) {
        if (normalize(models[j]) === target) return variants[i];
      }
    }
    return null;
  }

  // Capa 2: "Cubitt Teens Gen3" → "Teens"; "AURA Pro 2" prefiere "Aura Pro 2" sobre "Aura Pro"
  function matchByTitle(card, modelEl) {
    if (!modelEl) return null;

    var title = words(config.title);
    var index = parseInt(modelEl.dataset.ctlOption, 10);
    var best = null;
    var bestScore = 0;

    getVariants(card).forEach(function (variant) {
      String(variant.options[index] || '').split('/').forEach(function (part) {
        var tokens = words(part);
        if (!tokens.length || !containsSequence(title, tokens)) return;

        if (tokens.length > bestScore) {
          bestScore = tokens.length;
          best = variant;
        }
      });
    });

    return best;
  }

  function selectOptionValue(el, value) {
    if (!el) return;

    if (el.tagName === 'SELECT') {
      el.value = value;
      return;
    }

    el.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (input.value !== value) return;
      input.checked = true;

      // Si ese valor quedó oculto por el "+N", se despliega para que se vea seleccionado
      var label = el.querySelector('label[for="' + CSS.escape(input.id) + '"]');
      if (label && label.hidden) expandSwatches(el);
    });
  }

  function selectVariant(card, variant) {
    card.querySelectorAll('[data-ctl-option]').forEach(function (el) {
      selectOptionValue(el, variant.options[parseInt(el.dataset.ctlOption, 10)]);
    });
    applyVariant(card, variant);
  }

  function resolveModel(card) {
    var modelEl = getOptionEl(card, 'model');
    var variant = matchByMetafield(card) || matchByTitle(card, modelEl);

    if (variant) {
      selectVariant(card, variant);
      return;
    }

    // Sin opción de modelo (correas, cargadores…): se deja como lo renderizó Shopify
    if (!modelEl) return;

    // Capa 3: antes que preseleccionar un modelo equivocado, que elija el cliente
    card.dataset.ctlNeedsModel = 'true';

    if (modelEl.tagName === 'SELECT') {
      var placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = BUTTON_LABELS['select-model'].fallback;
      modelEl.insertBefore(placeholder, modelEl.firstChild);
      modelEl.value = '';
    } else {
      var checked = modelEl.querySelector('input:checked');
      if (checked) checked.checked = false;
    }

    applyVariant(card, null);
  }

  // Quita el placeholder una vez que el cliente eligió su modelo
  function clearNeedsModel(card) {
    if (card.dataset.ctlNeedsModel !== 'true') return;

    var modelEl = getOptionEl(card, 'model');
    if (modelEl && modelEl.tagName === 'SELECT') {
      if (!modelEl.value) return;
      var placeholder = modelEl.querySelector('option[value=""]');
      if (placeholder) placeholder.remove();
    }

    delete card.dataset.ctlNeedsModel;
  }

  function getSelectedOptions(card) {
    var values = [];
    card.querySelectorAll('[data-ctl-option]').forEach(function (el) {
      var index = parseInt(el.dataset.ctlOption, 10);
      if (el.tagName === 'SELECT') {
        values[index] = el.value;
      } else {
        var checked = el.querySelector('input:checked');
        values[index] = checked ? checked.value : null;
      }
    });
    return values;
  }

  function findVariant(card) {
    var selected = getSelectedOptions(card);
    var variants = getVariants(card);

    for (var i = 0; i < variants.length; i++) {
      var matches = variants[i].options.every(function (value, index) {
        return selected[index] == null || selected[index] === value;
      });
      if (matches) return variants[i];
    }
    return null;
  }

  function buildSrcset(url) {
    return IMAGE_WIDTHS.map(function (width) {
      return url.replace(/([?&])width=\d+/, '$1width=' + width) + ' ' + width + 'w';
    }).join(', ');
  }

  function setButton(button, status) {
    var label = BUTTON_LABELS[status];
    button.textContent = button.dataset[label.key] || label.fallback;
    button.dataset.status = status;
    button.disabled = status === 'sold-out' || status === 'adding' || status === 'select-model';
    button.setAttribute('aria-busy', status === 'adding' ? 'true' : 'false');
  }

  function applyVariant(card, variant) {
    var button = card.querySelector('[data-ctl-add]');
    card.dataset.variantId = variant ? String(variant.id) : '';

    if (variant) {
      card.querySelectorAll('[data-ctl-price]').forEach(function (el) {
        el.hidden = el.dataset.ctlPrice !== String(variant.id);
      });

      var image = card.querySelector('[data-ctl-image]');
      if (image && variant.image) {
        image.srcset = buildSrcset(variant.image);
        image.src = variant.image;
      }

      card.querySelectorAll('[data-ctl-link]').forEach(function (link) {
        link.setAttribute('href', variant.url);
      });
    }

    var addedQty = variant ? state.added[variant.id] || 0 : 0;
    updateInCartNotice(card, addedQty);

    if (button) {
      var status;
      if (!variant) {
        status = card.dataset.ctlNeedsModel === 'true' ? 'select-model' : 'sold-out';
      } else if (!variant.available) {
        status = 'sold-out';
      } else {
        status = addedQty > 0 ? 'add-again' : 'add';
      }
      setButton(button, status);
    }
  }

  /* ================================================================================================================
     ESTADO PERSISTENTE: LO AGREGADO DESDE EL MODAL
     ================================================================================================================ */

  var CHECK_ICON =
    '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false">' +
    '<path d="M3.5 8.3l3 3 6-6.6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';

  // Aviso "In your cart" encima del botón (se crea la primera vez que se necesita)
  function updateInCartNotice(card, qty) {
    var notice = card.querySelector('[data-ctl-in-cart]');

    if (!notice) {
      if (!qty) return;
      var button = card.querySelector('[data-ctl-add]');
      if (!button) return;

      notice = document.createElement('p');
      notice.className = 'ctl-card__in-cart';
      notice.setAttribute('data-ctl-in-cart', '');
      button.parentNode.insertBefore(notice, button);
    }

    notice.hidden = !qty;
    if (qty) {
      notice.innerHTML = CHECK_ICON + '<span>' + (qty > 1 ? qty + ' in your cart' : 'In your cart') + '</span>';
    }
  }

  function totalAdded() {
    return Object.keys(state.added).reduce(function (sum, id) {
      return sum + state.added[id];
    }, 0);
  }

  function updateViewCart() {
    if (!viewCartButton) return;
    var total = totalAdded();

    viewCartButton.textContent = total ? viewCartLabel + ' (' + total + ')' : viewCartLabel;
    viewCartButton.setAttribute(
      'aria-label',
      total ? viewCartLabel + ', ' + total + (total > 1 ? ' items' : ' item') + ' added' : viewCartLabel
    );
  }

  // Vuelve a pintar todas las tarjetas, sin interrumpir las que están agregando en este momento
  function refreshAllCards() {
    track.querySelectorAll('[data-ctl-card]').forEach(function (card) {
      var button = card.querySelector('[data-ctl-add]');
      var busy = button && (button.dataset.status === 'adding' || button.dataset.status === 'added');
      if (!busy) applyVariant(card, findVariant(card));
    });
    updateViewCart();
  }

  /**
   * Al abrir el modal se cruza lo registrado con el carrito real:
   * si el cliente quitó algo desde el Smart Cart, el aviso y el contador se corrigen.
   */
  function syncAddedWithCart() {
    if (!Object.keys(state.added).length) {
      updateViewCart();
      return Promise.resolve();
    }

    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var inCart = {};
        (cart.items || []).forEach(function (item) {
          var id = String(item.variant_id);
          inCart[id] = (inCart[id] || 0) + item.quantity;
        });

        Object.keys(state.added).forEach(function (id) {
          var qty = Math.min(state.added[id], inCart[id] || 0);
          if (qty > 0) state.added[id] = qty;
          else delete state.added[id];
        });

        refreshAllCards();
      })
      .catch(function () { updateViewCart(); });
  }

  /* ================================================================================================================
     AGREGAR AL CARRITO
     ================================================================================================================ */

  function isVariantInCart(variantId) {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        return (cart.items || []).some(function (item) { return Number(item.variant_id) === variantId; });
      });
  }

  function addToCart(variantId) {
    variantId = Number(variantId);
    var Rebuy = window.Rebuy;

    // Camino principal: Rebuy, para que el Smart Cart quede sincronizado
    if (Rebuy && Rebuy.Cart && typeof Rebuy.Cart.addItem === 'function') {
      return new Promise(function (resolve, reject) {
        var finished = false;

        function finish(ok, error) {
          if (finished) return;
          finished = true;
          document.removeEventListener('rebuy:cart.add', onAdd);
          clearTimeout(timer);
          if (ok) resolve();
          else reject(error);
        }

        function onAdd(event) {
          var item = event.detail && event.detail.item;
          if (!item || Number(item.variant_id || item.id) === variantId) finish(true);
        }

        // Si no llega confirmación, se verifica directamente en el carrito
        var timer = setTimeout(function () {
          isVariantInCart(variantId)
            .then(function (inCart) { finish(inCart, new Error('La variante no llegó al carrito')); })
            .catch(function (error) { finish(false, error); });
        }, FETCH_TIMEOUT);

        document.addEventListener('rebuy:cart.add', onAdd);

        try {
          var result = Rebuy.Cart.addItem({ id: variantId, quantity: 1 });
          if (result && typeof result.then === 'function') {
            result.then(function () { finish(true); }, function (error) { finish(false, error); });
          }
        } catch (error) {
          finish(false, error);
        }
      });
    }

    // Respaldo si Rebuy no cargó: Ajax API de Shopify
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart/add.js respondió ' + response.status);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    });
  }

  /* ================================================================================================================
     SLIDER (Swiper)
     ================================================================================================================ */

  function loadSwiper() {
    if (window.Swiper) return Promise.resolve();

    // Comparte la carga con related-products-slider para no descargar Swiper dos veces
    if (!document.querySelector('link[data-swiper-cdn]')) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = SWIPER_CSS;
      link.setAttribute('data-swiper-cdn', '');
      document.head.appendChild(link);
    }

    if (!document.querySelector('script[data-swiper-cdn]')) {
      var script = document.createElement('script');
      script.src = SWIPER_JS;
      script.async = true;
      script.setAttribute('data-swiper-cdn', '');
      document.head.appendChild(script);
    }

    return new Promise(function (resolve, reject) {
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        if (window.Swiper) {
          clearInterval(timer);
          resolve();
        } else if (tries > 120) {
          clearInterval(timer);
          reject(new Error('Swiper no cargó'));
        }
      }, 50);
    });
  }

  function initSlider() {
    return loadSwiper()
      .then(function () {
        if (state.swiper) {
          state.swiper.update();
          state.swiper.slideTo(0, 0);
        } else {
          state.swiper = new window.Swiper(modal.querySelector('.ctl-slider__viewport'), {
            slidesPerView: config.perView.mobile,
            spaceBetween: 12,
            watchOverflow: true,
            threshold: 5,
            grabCursor: true,
            observer: true,
            observeParents: true,
            a11y: { enabled: true },
            navigation: {
              nextEl: modal.querySelector('.ctl-slider__btn--next'),
              prevEl: modal.querySelector('.ctl-slider__btn--prev')
            },
            scrollbar: {
              el: modal.querySelector('.ctl-slider__scrollbar'),
              draggable: true,
              hide: false
            },
            breakpoints: {
              700: { slidesPerView: config.perView.tablet, spaceBetween: 16 },
              1000: { slidesPerView: config.perView.desktop, spaceBetween: 20 }
            }
          });
        }
      })
      .catch(function (error) {
        console.warn('[Complete the look]', error);
        modal.classList.add('ctl-modal--no-swiper'); // respaldo: scroll horizontal nativo
      });
  }

  /* ================================================================================================================
     SMART CART
     ================================================================================================================ */

  function hideSmartCart() {
    try {
      var smartCart = window.Rebuy && window.Rebuy.SmartCart;
      if (smartCart && smartCart.visible && typeof smartCart.hide === 'function') smartCart.hide();
    } catch (e) { /* Rebuy no disponible */ }
  }

  function showSmartCart() {
    var smartCart = window.Rebuy && window.Rebuy.SmartCart;
    if (smartCart && typeof smartCart.show === 'function') {
      smartCart.show();
    } else {
      window.location.href = root + 'cart';
    }
  }

  /* ================================================================================================================
     ABRIR / CERRAR
     ================================================================================================================ */

  function open() {
    if (state.isOpen) return;

    Promise.race([load(), delay(OPEN_MAX_WAIT, -1)]).then(function (count) {
      if (!count || count < 1 || state.isOpen) return; // sin sugeridos: flujo normal del Smart Cart

      state.isOpen = true;
      state.lastFocus = document.activeElement;

      modal.hidden = false;
      document.documentElement.classList.add('ctl-modal-lock');
      requestAnimationFrame(function () { modal.classList.add('is-open'); });

      if (config.hideSmartCart) hideSmartCart();

      initSlider();
      syncAddedWithCart();

      var closeButton = modal.querySelector('.ctl-modal__close');
      if (closeButton) closeButton.focus({ preventScroll: true });
    });
  }

  function close() {
    if (!state.isOpen) return;
    state.isOpen = false;

    modal.classList.remove('is-open');
    document.documentElement.classList.remove('ctl-modal-lock');

    setTimeout(function () {
      if (!state.isOpen) modal.hidden = true;
    }, reduceMotion ? 0 : 250);

    if (state.lastFocus && typeof state.lastFocus.focus === 'function') {
      state.lastFocus.focus({ preventScroll: true });
    }
  }

  /* ================================================================================================================
     EVENTOS
     ================================================================================================================ */

  // Disparador: solo cuando se agrega el producto de esta página
  document.addEventListener('rebuy:cart.add', function (event) {
    var item = event.detail && event.detail.item;
    if (!item || item.handle !== config.handle) return;
    open();
  });

  // Mientras el modal está abierto, el Smart Cart no se superpone
  document.addEventListener('rebuy:smartcart.show', function () {
    if (state.isOpen && config.hideSmartCart) hideSmartCart();
  });

  modal.addEventListener('click', function (event) {
    if (event.target.closest('[data-ctl-close]')) {
      close();
      return;
    }

    if (event.target.closest('[data-ctl-view-cart]')) {
      close();
      setTimeout(showSmartCart, reduceMotion ? 0 : 150);
    }
  });

  // Cambio de variante
  track.addEventListener('change', function (event) {
    if (!event.target.closest('[data-ctl-option]')) return;
    var card = event.target.closest('[data-ctl-card]');
    if (!card) return;

    clearNeedsModel(card);
    applyVariant(card, findVariant(card));

    // Con teclado (flechas) se puede llegar a un color oculto: se despliega la lista
    if (event.target.matches('input[type="radio"]')) {
      var label = card.querySelector('label[for="' + CSS.escape(event.target.id) + '"]');
      if (label && label.hidden) expandSwatches(event.target.closest('.ctl-card__swatches'));
    }
  });

  // Botón "+N" de colores y agregar al carrito
  track.addEventListener('click', function (event) {
    var more = event.target.closest('[data-ctl-more]');
    if (more) {
      expandSwatches(more.closest('.ctl-card__swatches'));
      return;
    }

    var button = event.target.closest('[data-ctl-add]');
    if (!button || button.disabled) return;

    var card = button.closest('[data-ctl-card]');
    var variantId = card && card.dataset.variantId;
    if (!variantId) return;

    var titleEl = card.querySelector('.product-card__title');
    var title = titleEl ? titleEl.textContent.trim() : 'Product';

    setButton(button, 'adding');

    addToCart(variantId)
      .then(function () {
        state.added[variantId] = (state.added[variantId] || 0) + 1;
        setButton(button, 'added');
        updateInCartNotice(card, state.added[variantId]);
        updateViewCart();
        announce(title + ' added to cart');
      })
      .catch(function (error) {
        console.warn('[Complete the look]', error);
        setButton(button, 'error');
        announce(title + ' could not be added. Try again.');
      })
      .then(function () {
        return delay(2500);
      })
      .then(function () {
        applyVariant(card, findVariant(card));
      });
  });

  // Teclado: Escape cierra, Tab queda dentro del modal
  document.addEventListener('keydown', function (event) {
    if (!state.isOpen) return;

    if (event.key === 'Escape') {
      close();
      return;
    }

    if (event.key !== 'Tab') return;

    var focusables = Array.prototype.filter.call(
      modal.querySelectorAll('a[href], button:not([disabled]), select, input[type="radio"]:checked'),
      function (el) { return el.getClientRects().length > 0; }
    );
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ================================================================================================================
     PRECARGA EN SEGUNDO PLANO
     ================================================================================================================ */

  function schedulePrefetch() {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(function () { load(); }, { timeout: 4000 });
    } else {
      setTimeout(load, 2000);
    }
  }

  if (document.readyState === 'complete') {
    schedulePrefetch();
  } else {
    window.addEventListener('load', schedulePrefetch, { once: true });
  }
})();
